import { render, staticRenderFns } from "./EditFaqs.vue?vue&type=template&id=29d5e128&"
import script from "./EditFaqs.vue?vue&type=script&lang=js&"
export * from "./EditFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports